module.exports = __webpack_public_path__ + "img/icon4.209b17a0.png";